<template>
  <div class="row">
    <div class="col">
      <h3>Welcome!</h3>
      <div v-if="!isSignedIn">
        You are not logged in <br /><br />
        <router-link to="/login">
          Login
        </router-link>
      </div>
      <div v-if="isSignedIn">
        <div class="alert alert-info">
          {{ userInfo }}
        </div>

        <router-link to="/logout">
          Logout <br /><br />
        </router-link>
      </div>

      <router-link to="/hello">
        Page for logged in users <br ><br />
      </router-link>
      <router-link to="/helloEverybody">
        Page for everyone
      </router-link>
    </div>
  </div>
</template>
<script>
import UserInfoStore from '../app/user-info-store';
import auth from '../app/auth';

export default {
  name: 'Home',
  data: function () {
    return {
      userInfo: UserInfoStore.state.cognitoInfo,
      user: auth.auth.getCurrentUser(),
      isSignedIn: auth.auth.isUserSignedIn()
    }
  }
}
</script>
<style>
</style>